import type { CheckoutOrderer } from '../../model/education-checkout.type';

/**
 * 개인 접수의 수강자 — 신청자 본인 1명이라 고를 게 없다.
 * 그래도 비워 두지 않는 이유: 무엇으로 접수되는지 확인하지 못한 채 결제로 넘어가면,
 * 결제 후에야 이름·연락처를 확인하게 된다.
 */
export function CheckoutPersonalAttendeeSection({
  orderer,
}: {
  orderer: CheckoutOrderer;
}) {
  return (
    <section
      className="overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-white/10 dark:bg-transparent"
      aria-labelledby="attendee-heading"
    >
      <div className="border-b border-gray-200 bg-gray-50/70 px-5 py-4 dark:border-white/10 dark:bg-white/[0.03]">
        <h2
          id="attendee-heading"
          className="text-base font-semibold text-gray-950 dark:text-neutral-100"
        >
          수강자
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-neutral-400">
          개인 접수는 신청자 본인 1명으로 접수됩니다.
        </p>
      </div>
      <dl className="grid gap-4 p-5 sm:grid-cols-3">
        <div>
          <dt className="text-xs font-semibold text-gray-600 dark:text-neutral-300">
            수강자명
          </dt>
          <dd className="mt-1.5 text-sm text-gray-900 dark:text-neutral-100">
            {orderer.ordererName || '-'}
          </dd>
        </div>
        <div>
          <dt className="text-xs font-semibold text-gray-600 dark:text-neutral-300">
            연락처
          </dt>
          <dd className="mt-1.5 text-sm tabular-nums text-gray-900 dark:text-neutral-100">
            {orderer.ordererPhone || '-'}
          </dd>
        </div>
        <div className="min-w-0">
          <dt className="text-xs font-semibold text-gray-600 dark:text-neutral-300">
            이메일
          </dt>
          <dd className="mt-1.5 truncate text-sm text-gray-900 dark:text-neutral-100">
            {orderer.ordererEmail || '-'}
          </dd>
        </div>
      </dl>
    </section>
  );
}
